import OrderDTO from "@/dto/order/OrderDTO";
import React from "react";
import * as OrderUtils from "@/utils/OrderUtils";
import { useGlobalStore } from "@/store/hooks";
import { SupplierShopTypes } from "@/utils/ShopUtils";
import { useModalStore } from "@/hooks/Modal/hooks";
import OrderMarkButton from "./OrderMarkButton";
import { Button } from "antd";
import UpdateDropShippingSellerRemarksModal from "../../../dialogs/UpdateDropShippingSellerRemarksDialog/UpdateDropShippingSellerRemarksModal";
import { observer } from "mobx-react-lite";
import SellerRemarks from "./SellerRemarks";

interface OrderRemarkProps {
    order: OrderDTO;

    onUpdateOrder?: (orderId: number, props: any) => void;
}

const OrderRemark: React.FC<OrderRemarkProps> = function (props) {
    const { order, onUpdateOrder } = props;
    const { shopMapping } = useGlobalStore();
    const modalStore = useModalStore();

    const buildBuyerRemarks = () => {
        const buyerRemarks = OrderUtils.buildBuyerRemarks(order);

        if (buyerRemarks) {
            return <p className="buyer-remarks">买家：{buyerRemarks}</p>;
        }
    };

    const buildSellerRemarksContent = () => {
        return (
            <p className="seller-remarks">
                <SellerRemarks order={order} onUpdateOrder={onUpdateOrder} />

                <OrderMarkButton order={order} onUpdateOrder={onUpdateOrder} />
            </p>
        );
    };

    const openUpdateDropShippingSellerRemarksModal = () => {
        modalStore.openModal(UpdateDropShippingSellerRemarksModal, {
            order,
            onUpdateOrder,
        });
    };

    const buildDropShippingSellerRemarks = () => {
        const dropshippingSellerRemarks =
            order?.retailerDropShippingInfo?.supplierRemarks || order?.supplierDropShippingInfo?.supplierRemarks;

        const shop = shopMapping.get(order.shopId);

        if (!shop) return null;

        const isSupplierShop = SupplierShopTypes.includes(shop.type);

        if (isSupplierShop && !dropshippingSellerRemarks) {
            return (
                <Button
                    type="link"
                    className="text-light link-btn fs12"
                    onClick={openUpdateDropShippingSellerRemarksModal}
                >
                    添加代发备注
                </Button>
            );
        } else if (isSupplierShop && dropshippingSellerRemarks) {
            return (
                <span style={{ color: "#3808C3" }} className="fs12">
                    代发备注：{dropshippingSellerRemarks}
                    <a
                        onClick={openUpdateDropShippingSellerRemarksModal}
                        href="#"
                        className="ml5 text-light link-btn mr5"
                    >
                        修改
                    </a>
                </span>
            );
        } else if (dropshippingSellerRemarks) {
            return (
                <span style={{ color: "#3808C3" }} className="fs12">
                    代发备注：{dropshippingSellerRemarks}
                </span>
            );
        }
    };

    const buyerRemarks = buildBuyerRemarks();

    const sellerRemarks = buildSellerRemarksContent();

    const dropShippingSellerRemarks = buildDropShippingSellerRemarks();

    return (
        <>
            {buyerRemarks}
            {sellerRemarks}
            {dropShippingSellerRemarks}
        </>
    );
};

export default observer(OrderRemark);
